import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyCollaborators = loadable(() => import(/* webpackChunkName: "content/guest/collaborators" */ './Collaborators'));
